/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star-shield-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M23.25 9.93h0c0 6.58-4.76 12.21-11.26 13.31l-.01-.01C5.48 22.13.73 16.5.73 9.91V.72h22.5zM.75 5.25h22.5"/><path pid="1" d="M12.53 8.792l1.24 2.458h2.12-.001c.32-.01.58.24.59.56 0 .16-.07.31-.18.43l-1.96 1.92 1.08 2.48h0c.12.3-.02.64-.32.77-.17.07-.37.05-.53-.04l-2.62-1.48-2.615 1.47v-.01c-.29.16-.65.06-.81-.22a.585.585 0 01-.04-.53l1.08-2.49-1.96-1.93-.01-.01a.586.586 0 01-.02-.83c.11-.12.26-.19.43-.18h2.12l1.24-2.46v-.01a.587.587 0 011.05-.01z"/></g>'
  }
})
